import { createReducer, createAction } from "redux-act";
import * as app from "./app";
import { message } from "antd";

export const REDUCER = "login";

export const LOGIN_ACTION = createAction(
  `${app.NS}login`,
  (username, password) => ({
    username,
    password
  })
);
export const RESET_PASSWORD_ACTION = createAction(
  `${app.NS}reset_password`,
  username => ({
    username
  })
);

/************************/
/*      LOGIN FORM      */
/************************/

const LOGIN_FORM_REQUEST = `${app.NS}user/login_form_request`;
export const LOGIN_FORM_REQUEST_ACTION = createAction(LOGIN_FORM_REQUEST);
const LOGIN_FORM_SUCCESS = `${app.NS}user/login_form_success`;
export const LOGIN_FORM_SUCCESS_ACTION = createAction(LOGIN_FORM_SUCCESS);
const LOGIN_FORM_FAILURE = `${app.NS}user/login_form_failure`;
export const LOGIN_FORM_FAILURE_ACTION = createAction(LOGIN_FORM_FAILURE);

export const loginFormRequest = id => {
  const action = LOGIN_FORM_REQUEST_ACTION(id);
  return action;
};
export const loginFormSuccess = user => {
  const action = LOGIN_FORM_SUCCESS_ACTION(user);
  return action;
};

export const loginFormFailure = error => {
  const action = LOGIN_FORM_FAILURE_ACTION(error);
  return action;
};

/************************/
/* RESET PASSWORD FORM  */
/************************/

const RESET_PASSWORD_FORM_REQUEST = `${app.NS}user/reset_password_form_request`;
export const RESET_PASSWORD_FORM_REQUEST_ACTION = createAction(
  RESET_PASSWORD_FORM_REQUEST
);
const RESET_PASSWORD_FORM_SUCCESS = `${app.NS}user/reset_password_form_success`;
export const RESET_PASSWORD_FORM_SUCCESS_ACTION = createAction(
  RESET_PASSWORD_FORM_SUCCESS
);
const RESET_PASSWORD_FORM_FAILURE = `${app.NS}user/reset_password_form_failure`;
export const RESET_PASSWORD_FORM_FAILURE_ACTION = createAction(
  RESET_PASSWORD_FORM_FAILURE
);

export const resetPasswordFormRequest = id => {
  const action = RESET_PASSWORD_FORM_REQUEST_ACTION(id);
  return action;
};
export const resetPasswordFormSuccess = user => {
  const action = RESET_PASSWORD_FORM_SUCCESS_ACTION(user);
  return action;
};

export const resetPasswordFormFailure = error => {
  const action = RESET_PASSWORD_FORM_FAILURE_ACTION(error);
  return action;
};

/************************/
/*      FORGOT FORM      */
/************************/

const FORGOT_FORM_REQUEST = `${app.NS}user/forgot_form_request`;
export const FORGOT_FORM_REQUEST_ACTION = createAction(FORGOT_FORM_REQUEST);
const FORGOT_FORM_SUCCESS = `${app.NS}user/forgot_form_success`;
export const FORGOT_FORM_SUCCESS_ACTION = createAction(FORGOT_FORM_SUCCESS);
const FORGOT_FORM_FAILURE = `${app.NS}user/forgot_form_failure`;
export const FORGOT_FORM_FAILURE_ACTION = createAction(FORGOT_FORM_FAILURE);

export const forgotPasswordFormRequest = id => {
  const action = FORGOT_FORM_REQUEST_ACTION(id);
  return action;
};
export const forgotPasswordFormSuccess = user => {
  const action = FORGOT_FORM_SUCCESS_ACTION(user);
  return action;
};

export const forgotPasswordFormFailure = error => {
  const action = FORGOT_FORM_FAILURE_ACTION(error);
  return action;
};

/*
export const submit = ({
  username,
  password
}: {
  username: string,
  password: string
}) => (dispatch: Function, getState: Function) => {
  dispatch(app.addSubmitForm(REDUCER));

  let isLoggined = app.login(username, password, dispatch);

  if (isLoggined) {
    dispatch(app.deleteSubmitForm(REDUCER));
  } else {
    dispatch(app.deleteSubmitForm(REDUCER));
    message.error("Invalid username or password");
  }
};

const initialState = {};
export default createReducer({}, initialState);*/



// WEBPACK FOOTER //
// ./src/ducks/login.js